"use client";

import { GalleryMediaItem } from "@/components/common/gallery";

// Unit spaces that should be prioritized
export const unitSpaces = ["halls", "bedrooms", "balconies", "kitchens", "bathrooms", "poojaRooms", "utilities"];

// Sorting function - prioritize by space order: halls, bedrooms, balconies, kitchens, then others
const getSpacePriority = (media: GalleryMediaItem): number => {
	if (!media.space || media.space === "") return 1000; // Project images last

	const index = unitSpaces.indexOf(media.space);
	if (index !== -1) return index; // Exact position: halls=0, bedrooms=1, balconies=2, kitchens=3, etc.

	return 500; // Other spaces in middle
};

export const sortMediaList = (mediaList: GalleryMediaItem[]): GalleryMediaItem[] => {
	// Filter out null/undefined items (may occur from GraphQL errors)
	const validItems = mediaList.filter(Boolean);
	return [...validItems].sort((a, b) => {
		// Get space priority based on unitSpaces order

		const priorityA = getSpacePriority(a);
		const priorityB = getSpacePriority(b);

		// Sort by space priority (lower number = higher priority)
		if (priorityA !== priorityB) {
			return priorityA - priorityB;
		}

		// If same space, maintain original order
		return 0;
	});
};
